import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import { styles } from '../../styles/auth-styles';

import { Auth } from "aws-amplify";

class SignIn extends React.Component {
  constructor(props) {
  super(props);

  this.state = {
    email: this.setUser(),
    password: "",
    rememberMe: this.setRememberMe()
  };
}

validateForm = () => {
  return this.state.email.length > 0 && this.state.password.length > 0;
}

handleChange = event => {
  this.setState({
    [event.target.id]: event.target.value
  });
}

handleSubmit = async event => {
  event.preventDefault();
  this.saveUser();
  try {
    await Auth.signIn(this.state.email, this.state.password);
    this.props.childProps.userHasAuthenticated(true);
  } catch (e) {
    console.log(e)
  }
}

handleRememberMe = (e) => {
  localStorage.setItem("rememberMe", e.target.checked);
  this.setState({
    rememberMe: e.target.checked
  })
}

setUser = () => {
  if(localStorage.getItem("rememberMe") === "true") {
    return localStorage.getItem("username");
  } else {
    return '';
  }
}

setRememberMe = () => {
  if(localStorage.getItem("rememberMe")!== null) {
    return JSON.parse(localStorage.getItem("rememberMe"));
  } else {
    return false;
  }
}

saveUser = () => {
  localStorage.setItem("username", this.state.email)
}

render() {
  const { classes } = this.props;

  return (
    <main className={classes.main}>
      <CssBaseline />
      <Paper className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} onSubmit={this.handleSubmit}>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="email">Email Address</InputLabel>
            <Input
              value={this.state.email}
              onChange={this.handleChange}
              id="email" name="email" type="email" autoComplete="email" autoFocus />
          </FormControl>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              value={this.state.password}
              onChange={this.handleChange}
              name="password" type="password" id="password" autoComplete="current-password" />
          </FormControl>
          <FormControlLabel
            control={<Checkbox value="remember" checked={this.state.rememberMe} color="primary" onChange={this.handleRememberMe} />}
            label="Remember me"
          />
          <Button
            disabled={!this.validateForm()}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign in
          </Button>
        </form>
      </Paper>
    </main>
    );
  }
}

SignIn.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignIn);



// WEBPACK FOOTER //
// ./src/components/auth/SignIn.js